import React, { useMemo } from 'react';
import { func, shape, bool, number } from 'prop-types';

// devExtreme
import HtmlEditor from 'devextreme-react/html-editor';
import TextArea from 'devextreme-react/text-area';

// utils
import {
  getHtmlEditorToolbar,
  getTextAreaEditorToolbar
} from './utils/toolbarItems';
import { getScriptsTxt } from './utils/switchSyntaxHandlers';

export { getScriptsTxt };

const ExtendedHtmlEditor = ({
  setHtmlEditorInstance,
  htmlEditorInstance,
  showRawHtml,
  setShowRawHtml,
  maxHtmlHeader = 3,
  htmlEditorOpts = {},
  txtEditorOpts = {},
  textAreaInstance,
  setTextAreaInstance,
  height,
  wrapperStyle,
  usingRefInstances = false
}) => {
  const getHtmlInst = () => {
    if (usingRefInstances) return htmlEditorInstance.current;

    return htmlEditorInstance;
  };

  const getTxtInst = () => {
    if (usingRefInstances) return textAreaInstance.current;

    return textAreaInstance;
  };

  const setTxtAreaValFromHtmlEditor = () => {
    const html = getHtmlInst().option('value');
    const htmlSwitchDecorated = getScriptsTxt(html);

    getTxtInst().option('value', htmlSwitchDecorated);
  };

  const handleTextAreaShow = () => {
    setTxtAreaValFromHtmlEditor();
    setShowRawHtml(true);
  };

  const handleTextAreaHide = () => {
    const textAreaValue = getTxtInst()
      .option('text')
      .replaceAll('\n<h1>', '<h1>')
      .replaceAll('\n<h2>', '<h2>')
      .replaceAll('\n<h3>', '<h3>')
      .replaceAll('\n<h4>', '<h4>')
      .replaceAll('\n<h5>', '<h5>')
      .replaceAll('\n<h6>', '<h6>')
      .replaceAll('\n', '<p>')
      .replaceAll('\\n', '<p>');

    getHtmlInst().option('value', textAreaValue);
    setShowRawHtml(false);
  };

  const editorToolbarItems = useMemo(() => {
    if (showRawHtml) {
      return getTextAreaEditorToolbar(handleTextAreaHide);
    }

    return getHtmlEditorToolbar(handleTextAreaShow, maxHtmlHeader);
  }, [showRawHtml, htmlEditorInstance, textAreaInstance]);

  const onHtmlEditorInit = (e) => {
    const { component } = e;

    const componentInstance = component.instance();

    setHtmlEditorInstance(componentInstance);

    if (htmlEditorOpts.onInitialized) {
      htmlEditorOpts.onInitialized(e);
    }
  };

  const onTextAreaInit = ({ component }) => {
    const componentInstance = component.instance();

    setTextAreaInstance(componentInstance);
  };

  // fix z rerenderowaniem toolbaru i jego duplikacją
  const renderingToolbar = useMemo(() => {
    return {
      container: null,
      items: editorToolbarItems,
      multiline: true
    };
  }, [editorToolbarItems]);

  return (
    <div
      className={`html-editor-wrapper ${
        showRawHtml ? 'html-editor-wrapper--raw-html' : ''
      }`}
      style={wrapperStyle}
    >
      <HtmlEditor
        className="html-editor"
        height={height}
        activeStateEnabled
        mediaResizing={{
          enabled: true,
          allowedTargets: ['images']
        }}
        toolbar={renderingToolbar}
        onInitialized={onHtmlEditorInit}
        {...htmlEditorOpts}
      />
      <TextArea
        className="html-editor-wrapper__text"
        onInitialized={onTextAreaInit}
        hoverStateEnabled={false}
        focusStateEnabled={false}
        {...txtEditorOpts}
      />
    </div>
  );
};

ExtendedHtmlEditor.propTypes = {
  setHtmlEditorInstance: func.isRequired,
  setTextAreaInstance: func.isRequired,
  setShowRawHtml: func.isRequired,
  height: number,
  htmlEditorOpts: shape({}),
  txtEditorOpts: shape({}),
  htmlEditorInstance: shape({
    option: func
  }),
  textAreaInstance: shape({
    option: func
  }),
  showRawHtml: bool.isRequired,
  maxHtmlHeader: number,
  wrapperStyle: shape({}),
  usingRefInstances: bool
};

export default ExtendedHtmlEditor;
